import React from 'react';
import './Maintenance.css';
import backgroundImage1 from '../Assets/maintenancepage.PNG'; // Vérifiez le chemin
import backgroundImage2 from '../Assets/maintenancepage2.PNG'; // Vérifiez le chemin

const Maintenance = () => {
  console.log('Rendering Maintenance component');
  console.log('backgroundImage1:', backgroundImage1);
  console.log('backgroundImage2:', backgroundImage2);

  return (
    <div className="maintenance-container">
      <div className="background-sections">
        <div
          className="background-section section-left"
          style={{
            backgroundImage: `url(${backgroundImage1})`,
            backgroundColor: '#ccc',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '500px', // Forcer une hauteur
          }}
          data-image={backgroundImage1}
        >
          <img src={backgroundImage1} alt="Maintenance background 1" style={{ display: 'none' }} />
          <div className="text-overlay">
            <h2>Service de Maintenance</h2>
            <p>Des solutions complètes pour assurer des opérations fluides et prolonger la durée de vie de vos actifs.</p>
          </div>
        </div>
        <div
          className="background-section section-right"
          style={{
            backgroundImage: `url(${backgroundImage2})`,
            backgroundColor: '#ccc',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '500px', // Forcer une hauteur
          }}
          data-image={backgroundImage2}
        >
          <img src={backgroundImage2} alt="Maintenance background 2" style={{ display: 'none' }} />
          <div className="text-overlay">
            <h2>Maintenance Préventive</h2>
            <p>Optimisez la performance avec des stratégies de maintenance proactives.</p>
          </div>
        </div>
      </div>
      <div className="maintenance-description">
        <h2>Notre Engagement</h2>
        <p>
          Nous assurons la maintenance complète des systèmes électriques et d’automatisation, tout en proposant des services de mise à niveau technologique et de gestion de l’obsolescence. Notre objectif est de maintenir vos installations à jour, fiables et conformes aux standards industriels, en remplaçant les composants vieillissants par des solutions modernes et performantes.
        </p>
      </div>
    </div>
  );
};

export default Maintenance;